export const seo = {
    home: {
        title: 'Dynamix Steel Fiber | High-Performance Concrete Reinforcement - Çorlu, Tekirdağ',
        description: 'Dynamix Steel Fiber manufactures high-performance hooked-end steel fibers for concrete reinforcement in Çorlu, Tekirdağ. Engineered solutions for dam construction, tunneling, industrial flooring, and infrastructure projects worldwide.',
        keywords: 'steel fiber, hooked-end steel fiber, concrete reinforcement, Dynamix, Çorlu steel fiber, Tekirdağ construction, dam construction, tunnel reinforcement, industrial flooring, shotcrete, UHPC, infrastructure, construction materials',
        schema: {
            webPage: {
                name: 'Dynamix Steel Fiber - Home',
                description: 'High-performance steel fiber reinforcement for concrete structures'
            }
        }
    },
    product: {
        title: 'Hooked-End Steel Fiber Products | Dynamix - Çorlu, Tekirdağ',
        description: 'Premium quality hooked-end steel fiber reinforcement for concrete. Technical specifications: 30-60mm length, 0.5-1.2mm diameter, >1100 MPa tensile strength. ASTM A820 compliant. Ideal for dam construction, tunneling, and industrial flooring.',
        keywords: 'hooked-end steel fiber, steel fiber specifications, concrete reinforcement product, ASTM A820, high tensile strength fiber, cold-drawn steel fiber, Dynamix products, construction materials Tekirdağ'
    },
    applications: {
        title: 'Steel Fiber Applications | Dam, Tunnel, Industrial Flooring - Dynamix',
        description: 'Discover Dynamix steel fiber applications: dam construction, tunneling & underground works, industrial flooring, precast elements, pavements, foundation slabs, water tanks, and blast-resistant structures. Engineering solutions for infrastructure projects.',
        keywords: 'steel fiber applications, dam construction reinforcement, tunnel shotcrete, industrial flooring concrete, precast concrete fiber, pavement reinforcement, foundation slab fiber, infrastructure applications, construction solutions',
        schema: {
            webPage: {
                name: 'Steel Fiber Applications',
                description: 'Comprehensive applications of Dynamix steel fiber in construction projects'
            }
        }
    },
    about: {
        title: 'About Dynamix Steel Fiber | Our Story, Mission & Values - Çorlu, Tekirdağ',
        description: 'Learn about Dynamix Steel Fiber: innovative steel fiber manufacturer in Çorlu, Tekirdağ. Our mission is to provide high-quality steel fiber solutions for durable concrete structures. Committed to quality excellence, innovation, integrity, and sustainability.',
        keywords: 'about Dynamix, steel fiber manufacturer, Çorlu Tekirdağ company, construction materials company, steel fiber innovation, quality manufacturing, sustainable construction, engineering solutions',
        schema: {
            webPage: {
                name: 'About Dynamix Steel Fiber',
                description: 'Company information, mission, vision, and core values'
            }
        }
    },
    contact: {
        title: 'Contact Dynamix Steel Fiber | Get in Touch - Çorlu, Tekirdağ',
        description: 'Contact Dynamix Steel Fiber in Çorlu, Tekirdağ. Address: Şeyh Sinan, Hüsmen Kalfa Sk. No:5/33, 59850 Çorlu/Tekirdağ. Phone: +90 530 095 97 41. Email: info@dynamixsteelfiber.com. Office hours: Mon-Fri 8AM-6PM, Sat 9AM-2PM.',
        keywords: 'contact Dynamix, steel fiber supplier contact, Çorlu Tekirdağ address, construction materials inquiry, steel fiber quote, Dynamix phone number, Dynamix email'
    }
};
